import { render } from "./MyReservations.vue?vue&type=template&id=d2c532d6"
import script from "./MyReservations.vue?vue&type=script&lang=js"
export * from "./MyReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__